











































































































import moment from "moment";
import { Component, Vue, Ref, Prop } from "vue-property-decorator";
import MaintenanceTable from './MaintenanceTable.vue'
import { DeviceServiceProxy } from '@/service-proxies/app-v2/workStation.service-proxies'
import { MaintainItemServiceProxy, MaintainPlanServiceProxy } from '@/service-proxies/app-v2/tpm.service-proxies'
import dayjs from "dayjs";

const mpsp = new MaintainPlanServiceProxy()
const misp = new MaintainItemServiceProxy()
const dsp = new DeviceServiceProxy()

export default Vue.extend({
  data(){
    return {
      labelCol: { span: 6 },
      wrapperCol: { span: 12 },
      form: this.$form.createForm(this),
      loading: false,
      selectDevice: {},
      dataSource: [],
      count: 0,
      maintainItemList: []
    }
  },
  components:{
    MaintenanceTable
  },
  props:{
    visible:{
      type: Boolean,
      default: false
    },
    editData:{
      type: Object,
      default: () => ({})
    },
  },
  watch:{
    visible:{
      handler(){
        if(this.visible){
          misp.queryMaintainItemList("").then(res =>{
            this.maintainItemList = res
          })
          this.getDataSourse()
        }
      },
      deep: true,
      immediate: true
    }
  },
  methods:{
    moment,
    disabledDate(current) {
      return current && current < moment().startOf('day');
    },
    getDataSourse(){
      this.form.resetFields()
      this.dataSource = []
      this.selectDevice = {}
      mpsp.getMaintainPlan(this.editData.id).then(res =>{
        if(res) {
          this.selectDevice = res
          res.maintainPlanItemVoList.forEach((item,index) => {
            const data = {
              key: index,
              id: item.itemId,
              code: item.itemCode,
              name: item.itemName,
              remark: item.itemRemark,
              requirement: item.itemRequirement
            }
            this.dataSource.push(data)
          })
          this.count = this.dataSource.length
        }
      })
    },
    reset(){
      this.form.resetFields()
      this.dataSource = []
      this.count = 0
      this.selectDevice = {}
    },
    close(){
      this.reset()
      this.$emit('close')
    },
    save(){
      this.form.validateFields((err,values) => {
        if(!err){
          Object.keys(values).forEach(key => {
            const item = values[key]
            values[key] = (values[key] && (typeof item) == 'string') ? values[key].replace(/\s*/g,"") : values[key]
          });
          const maintainItemList = JSON.parse(JSON.stringify(this.dataSource))
          const list = []
          const canSave = true
          maintainItemList.forEach(res => {
            if(res.id !== "") {
              const value = {
                itemId: res.id,
                projectId: ""
              }
              list.push(value)
            }
          });
          if(list.length < 1){
            this.$message.warning(this.$t('page_plan_maintenance_please_add_program'))
            return
          }
          if(list && list.length > 0){
            const data = {...this.selectDevice}
            data.maintainItemList = list
            data.projectName = values.projectName
            data.preWarningDays = values.preWarningDays
            data.projectCode = values.projectCode
            data.maintainDate = dayjs(values.maintainDate).format('YYYY-MM-DD HH:mm:ss')
            this.loading = true
            mpsp.editMaintainPlan(data).then(() => {
              this.$message.success(this.$t('page_mdc_setting_edit_success'))
              this.reset()
              this.$emit('reload')
              this.loading = false
            }).catch(() => {this.loading = false})
          }
        }
      })
    },
    onDelete(key) {
      const dataSource = [...this.dataSource];
      this.dataSource = dataSource.filter(item => item.key !== key);
    },
    handleAdd() {
      const { count, dataSource } = this;
      const newData = {
        key: count,
        code: "",
        name: "",
        requirement: "",
        remark: ""
      };
      this.dataSource = [...dataSource, newData];
      this.count = count + 1;
    },
    handleChange(value, key) {
      const has = this.dataSource.find(res => res.code === value)
      if(has != undefined){
        this.$message.warning(this.$t('page_plan_maintenance_not_choose_same'))
        return
      }
      const newData = [...this.dataSource];
      const target = newData.filter(item => key === item.key)[0];
      const data = this.maintainItemList.find(res => res.code === value)
      if (target && data) {
        target['id'] = data.id;
        target['code'] = value;
        target['name'] = data.name;
        target['requirement'] = data.requirement;
        target['remark'] = data.remark;
        this.dataSource = newData;
      }
    },
  }
})

